import { render, staticRenderFns } from "./DepartmentModal.vue?vue&type=template&id=25aecc12&scoped=true&"
import script from "./DepartmentModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aecc12",
  null
  
)

export default component.exports